<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div>
          <img class="img-fluid"
               src="https://storage.googleapis.com/eyelation_images/Shared/Eyelation-Logo-160x35.png">
        </div>
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.
          </p>
          <a class="btn gray-btn" href="/login">Back to login</a>
        </div>
      </div>
    </div>
  </div>
</div>
